export default {
  notifications: {},
  notificationSettings: {},
  hooks: {},
}